<template>
  <div class="product-management">

    <!-- 搜索过滤栏 -->
    <div class="filter-bar">
      <el-input v-model="search.title" placeholder="商品名称" style="width: 140px;" size="small"></el-input>
      <!-- <el-input v-model="search.id" placeholder="商品ID 多个ID以逗号或空格分隔" style="width: 220px;" size="small"></el-input>
      <el-input v-model="search.code" placeholder="商家编码" style="width: 140px;" size="small"></el-input> -->
      <el-select clearable @change="classSelectChange" size="small" style="width: 220px;" v-model="search.class_no"
        placeholder="请选择商品分类编号" filterable>
        <el-option v-for="item in class_list" :key="item.class_no" :label="item.class_name" :value="item.class_no" />
      </el-select>
      <el-button type="primary" size="small" icon="el-icon-search" @click="searchTitle">搜索</el-button>
      <el-button size="small" @click="resetSearch">重置</el-button>
      <el-button type="primary" size="small" @click="publishProduct">+ 创建新商品</el-button>
    </div>

    <!-- 商品状态标签 + 发布商品按钮 -->
    <!-- <div class="status-bar">
      <div class="status-tabs">
        <span @click="tabsChange(item.key)" class="status-tab" :class="item.key === active_key ? 'active' : ''"
          v-for="(item, index) in baseList.tab_list" :key="index">{{ item.label }} {{ item.value }}</span>
      </div>
      <div class="action-buttons">

        <el-button type="primary" size="small" @click="publishProduct">+ 发布商品</el-button>

        <el-button size="small" @click="moreBatch">更多批量操作</el-button>
      </div>
    </div> -->
    <!-- 批量操作栏（简易） -->
    <!-- <div class="batch-bar">
      已选 {{ selectedCount }} 件商品
      <el-button type="text" size="small" @click="batchOffline">批量下架</el-button>
      <span class="page-info"> &lt; 1/2 &gt; </span>
    </div> -->
    <!-- Easy-Table 商品列表 -->
    <!-- eslint-disable -->
    <div class="table-fa">
      <ve-table id="loading-container" border-x ref="goodstableRef" :columns="tabColumn" :fixed-header="true"
        :maxHeight="`700px`" rowKeyFieldName="rowKey" :table-data="goodsList" :rowStyleOption="rowStyleOption"
        :checkbox-option="checkboxOption" :cell-style-option="cellStyleOption"
        :virtual-scroll-option="virtualScrollOption" enable="true" />
      <div class="in-line un-selected">
        调整每页显示条数
        <el-select class="un-selected" v-model="pagination.pageSize" :disabled="pagination.disabled"
          @change="getGoodsList" style="margin: 0 20px; width: 100px !important" placeholder="请选择" size="mini">
          <el-option v-for="item in pagination.pageSizes" :key="item" :label="item + '条 / 页'" :value="item">
          </el-option>
        </el-select>

        <el-button type="primary" :disabled="pagination.disabled" @click="pageChange('-')" plain
          size="mini">上一页</el-button>
        <div style="margin: 0 20px; display: flex; align-items: center">
          第<el-input :min="1" type="number" @change="getGoodsList" :disabled="pagination.disabled" :max="100"
            style="margin: 0 20px; width: 100px !important" id="page-input" size="mini"
            v-model="pagination.currentPage"></el-input>
          页
        </div>
        <el-button type="primary" :disabled="pagination.disabled" @click="pageChange('+')" plain
          size="mini">下一页</el-button>
      </div>
    </div>

    <div class="empty-block"></div>

  </div>
</template>

<script>
import { myFixed } from "@/js/public.js"
import baseList from '../../data/goodsList.js';
import { mapMutations } from "vuex";
import { onlinesGoodsList, onlinesGetClassifyList } from "@/api/onlines/goods.js";
import { basicDownLoadImg } from "@/api/basic.js";
export default {
  name: 'ProductList',
  data() {
    return {
      pagination: {
        pageSizes: [20, 50, 100],
        pageSize: 20,
        currentPage: 0,
        disabled: false
      },
      baseList: baseList, //基本的配置
      active_key: 'all', // 当前选中的状态标签key
      tabColumn: [
        {
          field: "checkbox",
          key: "checkbox",
          // type=checkbox
          type: "checkbox",
          title: "",
          width: 50,
          align: "center"
        },
        {
          field: "",
          key: "a",
          title: "索引",
          width: 50,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.rowKey + 1;
          }
        }, {
          field: "goods_name",
          key: "goods_name",
          title: "商品名称",
          align: "center",
          width: "12%",
          ellipsis: {
            showTitle: true
          }
        }, {
          field: "sale_price",
          key: "sale_price",
          title: "销售价",
          align: "center",
          width: "8%",
          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "stock",
          key: "stock",
          title: "库存",
          align: "center",
          width: "8%",
          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "sale_count",
          key: "sale_count",
          title: "累计销量",
          width: "8%",
          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "class_no",
          key: "class_no",
          title: "类别",
          width: "8%",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {this.getClassName(row.class_no) || row.class_no}
              </span>
            )
          }
        },
        {
          field: "create_time",
          key: "create_time",
          title: "创建时间",
          width: "11%",
          ellipsis: {
            showTitle: true
          }
        }, {
          field: "sale_time",
          key: "sale_time",
          title: "发布时间",
          width: "11%",
          ellipsis: {
            showTitle: true
          }
        }, {
          field: "set",
          key: "set",
          title: "操作",
          width: "12%",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                <el-button type="text" size="small" on-click={() => this.editProduct(row)}>编辑商品</el-button>
                &nbsp;
                <br />
                <el-button type="text" size="small" on-click={() => this.editProduct(row)}>更多</el-button>
              </span>
            )
          }
        }
      ],
      /* {
          field: "item_image",
          key: "item_image",
          title: "商品图片",
          width: "10%",
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            if (row.banner) {
              return h('el-image', {
                style: 'width:100px;height:100px;position:relative;',
                attrs: {
                  src: this.getRowImage(row) // 不需要 await
                }
              });
            } else {
              return h('el-image', {
                style: 'width:100px;height:100px;position:relative;',
                attrs: {
                  src: row.image_url
                }
              });
            }
          }
        }, */
      /* /* <template slot="actions" slot-scope="{ row }">
                <div class="action-buttons-cell">
                  <el-button type="text" size="small" @click="editProduct(row)">编辑商品</el-button>
                  <el-button type="text" size="small" @click="decorateProduct(row)">商品装修</el-button>
                  <div class="extra-links">
                    <span class="link" @click="createChannel(row)">创建渠道商品</span>
                    <span class="link" @click="moreActions(row)" > 更多</span >
                      <span class="share-link" @click="shareProduct(row)" > C分享</span >
                  </div>
                </div>
              </template> */
      rowStyleOption: {},
      cellStyleOption: {},
      virtualScrollOption: {},
      checkboxOption: {},
      // 表格列定义
      columns: [
        { label: '商品名称', field: 'name', useSlot: true, slotName: 'name', width: '260px' },
        { label: '价格', field: 'price', width: '90px' },
        { label: '库存', field: 'stock', useSlot: true, slotName: 'stock', width: '70px' },
        { label: '累计销量?', field: 'accSales', useSlot: true, slotName: 'sales', width: '90px' },
        { label: '30日销量?', field: 'monthSales', useSlot: true, slotName: 'sales', width: '90px' }, // 共用销量slot
        { label: '质量分?', useSlot: true, slotName: 'qualityScore', width: '150px' },
        { label: '创建时间', useSlot: true, slotName: 'time', width: '160px' },
        { label: '发布时间', useSlot: true, slotName: 'time', width: '160px' }, // 共用时间slot
        { label: '操作?', useSlot: true, slotName: 'actions', width: '180px' }
      ],
      // 原始商品数据 (根据截图模拟)
      goodsList: [
      ],
      allGoodsList: [],
      class_list: [],
      search: {
        title: '',
        id: '',
        code: '',
        quality: '',
        class_no: ''
      },
      selectedRows: [], // 选中的行数据
      selectAll: false
    }
  },
  computed: {
    filteredProducts() {
      // 简单过滤：根据标题和ID过滤 (仅演示)
      let filtered = this.products;
      if (this.search.title) {
        filtered = filtered.filter(p => p.name.includes(this.search.title));
      }
      if (this.search.id) {
        filtered = filtered.filter(p => p.id.includes(this.search.id));
      }
      // 其他过滤可扩展
      return filtered;
    },
    selectedCount() {
      return this.selectedRows.length;
    }
  },
  mounted() {
    this.getGoodsList();
    this.getClassifyList();
  },
  methods: {
    ...mapMutations("home", ["UPDATEMENUTABS", "CLEARTABS", "ADDTABS"]),
    /**
     * 点击上一页或者下一页
     * @param {"+"|"-"} key
     */
    pageChange(key) {
      if (key === "+") {
        this.pagination.currentPage += 1;
        if (this.pagination.currentPage > 100) {
          this.pagination.currentPage = 100;
        }
      } else if (key === "-") {
        this.pagination.currentPage -= 1;
        if (this.pagination.currentPage < 0) this.pagination.currentPage = 0;
      }
      this.getGoodsList();
    },
    async getRowImage(row) {
      console.log("row", row);
      if (row.banner) {
        const banner = JSON.parse(row.banner);
        if (banner[0]) {
          if (banner[0].url.indexOf("http") === -1 && banner[0].url.length === 64) {
            return "data:image/png;base64," + await basicDownLoadImg(banner[0].url);
          } else {
            return banner[0].url;
          }
        }
      }
    },
    searchTitle() {
      if (this.search.title === "" || this.search.title.length === 0) {
        this.goodsList = this.allGoodsList;
        return;
      }
      this.goodsList = this.allGoodsList.filter(item => {
        return item.goods_name.indexOf(this.search.title.trim()) > -1
      })
    },
    /**
     * 类别选择器修改
     * @param e
     */
    classSelectChange(e) {
      if (!e || e === "" || e.length === 0) {
        this.goodsList = this.allGoodsList;
        return;
      }
      this.goodsList = this.allGoodsList.filter(item => {
        return item.class_no.trim() === e.trim()
      })
    },
    /**
     * 获取所有线上类别
     */
    async getClassifyList() {
      const res = await onlinesGetClassifyList();
      this.class_list = res;
    },
    getClassName(class_no) {
      const classItem = this.class_list.find(
        item => item.class_no.trim() === class_no.trim()
      )
      return classItem?.class_name || null;
    },
    /**
     * 获取商品列表
     */
    async getGoodsList() {
      const res = await onlinesGoodsList(this.pagination.currentPage, this.pagination.pageSize);
      this.goodsList = res.map((item, index) => {
        return {
          ...item,
          sale_price: myFixed(item.sale_price * 0.01, 2),
          rowKey: index
        }
      });
      this.allGoodsList = JSON.parse(JSON.stringify(this.goodsList));
    },
    /**
     * 点击tab 切换key
     * @param {string} key 点击哪个属性
     */
    tabsChange(key) {
      this.active_key = key;
    },
    // 搜索重置
    resetSearch() {
      this.search = { title: '', id: '', code: '', quality: '', class_no: '' };
      this.goodsList = this.allGoodsList;
    },
    // 全选逻辑
    handleSelectAll(val) {
      this.selectedRows = val ? [...this.filteredProducts] : [];
    },
    // 行选中回调 (easy-table 可能通过 @check 返回选中行)
    handleCheck(checkedRows) {
      this.selectedRows = checkedRows;
      // 更新全选状态
      this.selectAll = checkedRows.length === this.filteredProducts.length && this.filteredProducts.length > 0;
    },
    // 批量下架
    batchOffline() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择商品');
        return;
      }
      this.$message.success(`批量下架 ${this.selectedRows.length} 件商品`);
    },
    // 发布商品
    publishProduct() {
      this.UPDATEMENUTABS("/goodsUpload");
      this.$router.push({ name: 'goodsUpload', params: { key: 'create' } });
      this.ADDTABS({
        activePath: "/goodsUpload",
        title: "商品详情"
      });
    },
    // 更多批量操作
    moreBatch() {
      this.$message.info('更多批量操作');
    },
    // 编辑商品
    editProduct(row) {
      this.UPDATEMENUTABS("/goodsUpload");
      this.$router.push({ name: 'goodsUpload', params: { key: 'update', value: JSON.stringify(row) } });
      this.ADDTABS({
        activePath: "/goodsUpload",
        title: "商品详情"
      });
      console.log("row----------------", row);
    },
    // 商品装修
    decorateProduct(row) {
      this.$message.info(`装修商品: ${row.name}`);
    },
    // 创建渠道商品
    createChannel(row) {
      this.$message.info(`创建渠道商品: ${row.id}`);
    },
    // 更多操作
    moreActions(row) {
      this.$message.info(`更多操作: ${row.name}`);
    },
    // 分享
    shareProduct(row) {
      this.$message.info(`分享商品: ${row.name}`);
    }
  }
}
</script>

<style scoped>
.in-line {
  display: flex;
  width: 100%;
  height: 40px;
  align-items: center;
  justify-content: right;

}

.table-fa {
  width: 100%;
  border-radius: 8px;
  padding: 10px;
  background-color: #fff;
}

.product-management {
  width: 99%;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.nav-header {
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
}

.nav-item.active {
  color: #333;
  font-weight: 500;
}

.separator {
  margin: 0 6px;
  color: #ccc;
}

.status-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  background: white;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.status-tabs {
  display: flex;
  gap: 20px;
}

.status-tab {
  font-size: 14px;
  color: #666;
  cursor: pointer;
}

.status-tab.active {
  color: #007aff;
  font-weight: 500;
  position: relative;
}

.status-tab.active::after {
  content: '';
  position: absolute;
  bottom: -12px;
  left: 0;
  right: 0;
  height: 2px;
  background: #007aff;
}

.filter-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  background: white;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.sort-link {
  color: #007aff;
  font-size: 13px;
  cursor: pointer;
  margin-left: auto;
}

.batch-bar {
  display: flex;
  align-items: center;
  gap: 20px;
  background: white;
  padding: 10px 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.page-info {
  margin-left: auto;
  color: #999;
  font-size: 13px;
}

/* Easy-Table 内部自定义样式 */
.product-name-cell .main-title {
  font-weight: 500;
  margin-bottom: 4px;
}

.meta-info {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 12px;
  color: #999;
  align-items: center;
}

.meta-info .id {
  color: #666;
}

.meta-info .tag {
  background: #f0f2f5;
  padding: 2px 6px;
  border-radius: 4px;
  color: #666;
}

.meta-info .tag.accent {
  background: #e6f7ff;
  color: #007aff;
}

.meta-info .action-link {
  color: #007aff;
  cursor: pointer;
}

.sub-text {
  font-size: 12px;
  color: #999;
}

.quality-wrapper {
  font-size: 12px;
  line-height: 1.6;
}

.quality-wrapper .score-dot {
  color: #ff9900;
  font-weight: bold;
}

.fy-score {
  color: #666;
}

.fy-score.muted {
  color: #bbb;
}

.action-buttons-cell {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.action-buttons-cell .el-button--text {
  padding: 0;
  margin-right: 8px;
  font-size: 12px;
}

.extra-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 12px;
  color: #007aff;
  cursor: pointer;
}

.extra-links .link:hover,
.share-link:hover {
  text-decoration: underline;
}

.share-link {
  color: #007aff;
}

.footer-pagination {
  margin-top: 20px;
  text-align: right;
  font-size: 13px;
  color: #999;
}

/* 覆盖 easy-table 默认样式，确保紧凑 */
.easy-table th,
.easy-table td {
  padding: 12px 8px !important;
  font-size: 13px;
}
</style>